import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import {
  IConfigurationRolesAndPermissionSingleDetailsResponse,
  IConfigurationRolesAndPermissionSingleDetailsResponseData,
} from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";

import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";

AxiosCurlirize(axios, () => {});
export const useConfigurationRBACDetailsAPI = () => {
  const [roleDetails, setRoleDetails] = useState<IConfigurationRolesAndPermissionSingleDetailsResponseData>(null);
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (roleId: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        if (!roleId) {
          return;
        }
        const response: IConfigurationRolesAndPermissionSingleDetailsResponseData = await axios
          .get(`${CONFIGURATION_APIS?.GET_ROLE_DETAILS?.baseURL}`, {
            params: { role_id: roleId },
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IConfigurationRolesAndPermissionSingleDetailsResponse>) => {
            if (res.data.status === true) {
              setRoleDetails(res.data.data);
              return res.data.data;
            } else {
              toast.error("Error while fetching service details.");
              return null;
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            return null;
          });
        return response;
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          if (axiosError.code === "ERR_BAD_REQUEST") {
            toast.error("Error at server while fetching city details.");
          }
          if (axiosError.response?.status === 400) {
            toast.error(axiosError.message);
          }
          if (axiosError.response?.status === 500) {
            toast.error("Internal Server Error, Contact Tech Team.");
          }
        } else {
          toast.error("Server Error: " + error.message);
        }
        return null;
      }
    },
    [dispatch, configuration],
  );

  return { roleDetails, execute };
};
